import type { GridColDef } from "src/components/DataGrid/DataGrid.tsx";
import { ResourceEnum } from "src/constants/constants.ts";
import { ProductTypeCell } from "src/components/Form/panels/TransferPanel/components/ProductTypeCell.tsx";
import { formatDefinitionAttributes } from "src/admin/modules/variant/utils/formatAttributeValues.ts";
import type { TFunction } from "i18next";
import { useMemo } from "react";

export const useTransferListDataGridColumns = ({
  resource,
  formResource,
  t,
}: {
  resource: string;
  formResource: string;
  t: TFunction;
}) => {
  return useMemo(
    () =>
      translateColumns({
        columns: getColumns({
          resource,
          formResource,
        }),
        t,
        resource,
      }),
    [resource, formResource, t],
  );
};
const getColumns = ({
  resource,
  formResource,
}: {
  resource: string;
  formResource: string;
}): GridColDef<any>[] => {
  if (resource === ResourceEnum.CustomerGroup) {
    return [
      {
        field: "title",
        flex: 1,
      },
    ];
  }
  if (resource === ResourceEnum.Customer) {
    return [
      {
        field: "first_name",
        flex: 1,
      },
      {
        field: "last_name",
        flex: 1,
      },
    ];
  }
  if (resource === ResourceEnum.Country) {
    return [
      {
        field: "name",
        flex: 1,
      },
      {
        field: "alpha2_code",
        flex: 1,
        backendFilterName: "alpha2_code",
      },
    ];
  }
  if (resource === ResourceEnum.Variant) {
    if (formResource === ResourceEnum.Manufacturer) {
      return [
        {
          field: "title",
          flex: 1,
        },
      ];
    }
    return [
      {
        field: "item_type",
        width: 40,
        minWidth: 40,
        headerName: "",
        filterable: false,
        renderHeaderFilter: () => null,
        renderCell: ProductTypeCell,
      },
      {
        field: "title",
        flex: 1,
      },
      {
        field: "selection",
        flex: 1,
        valueGetter: (value, row) => {
          return formatDefinitionAttributes(
            row?.definitionAttributeValues || [],
          );
        },
      },

      {
        field: "sku",
        flex: 1,
        // hideHeaderFilterOperators: true,
      },
    ];
  }
  if (resource === ResourceEnum.ProductGroup) {
    return [
      {
        field: "title",
        flex: 1,
      },
    ];
  }
  if (resource === ResourceEnum.DeliveryService) {
    return [
      {
        field: "title",
        flex: 1,
      },
    ];
  }
  return [];
};

const translateColumns = ({
  columns,
  t,
  resource,
}: {
  columns: GridColDef<any>[];
  resource: string;
  t: TFunction;
}) => {
  return columns.map((column) => ({
    headerName: t(`${resource}.column.${column.field}`),
    ...column,
  }));
};
